import moment from 'moment-timezone';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, Redirect } from 'react-router-dom';
import { Alert, Button, Table } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as MySettings from '../store/Settings';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as Records from '../store/Records';
import * as utility from '../data/Utility';
import * as sortfilter from '../data/SortFilter';

const recordTableBodyId = "recordTableBody";
const resizeEventType = "resize";


class SelectRecordInternal extends React.Component {
    constructor(props) {
        super(props);

        var patientCode = props.recordsState.allPatientCode;
        var patientId = props.recordsState.allPatientId;
        var siteId = props.recordsState.allSiteId;
        var siteName = props.recordsState.allSiteName;
        var studyId = props.recordsState.allStudyId;
        var studyName = props.recordsState.allStudyName;
		var selectedId = "";

        if (props.patientCode != null) {
            patientCode = props.patientCode;
        }
        if (props.patientId != null) {
            patientId = props.patientId;
        }
        if (props.siteId != null) {
            siteId = props.siteId;
        }
        if (props.siteName != null) {
            siteName = props.siteName;
        }
        if (props.studyId != null) {
            studyId = props.studyId;
        }
        if (props.studyName != null) {
            studyName = props.studyName;
        }
        if ( props.selectedId ) {
            selectedId = props.selectedId;
        }

		/* find the crf questions for this patient's study */
		var crfQnaEvent = [];
		var crfQnaHolter = [];
		var crfQna12Lead = [];
		if ( this.props.recordsState.all ) {
			const rec = this.props.recordsState.all.find( function (rec) { return rec.patientCode === patientCode } );
			if ( rec ) {
				crfQnaEvent = rec.crfQnaEvent;
				crfQnaHolter = rec.crfQnaHolter;
				crfQna12Lead = rec.crfQna12Lead;
			}
		}

        this.state = {
            activeId: "",
            selectedId: selectedId,
			columnsUsed: null,
			crfQnaEvent: crfQnaEvent,
			crfQnaHolter: crfQnaHolter,
			crfQna12Lead: crfQna12Lead,
			currentFilters: {},
			currentSortDirection: {},
			currentSortingColumn: '',
			isShowingFilter: false,
            scroll: false,
            patientCode: patientCode,
            patientId: patientId,
            serviceType: "",
            siteId: siteId,
            siteName: siteName,
            studyId: studyId,
            studyName: studyName,
			initCount: 0,
            isInitializing: false
        };

        this.initialize = this.initialize.bind(this);
        this.updateTableSize = this.updateTableSize.bind(this);
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
        window.addEventListener(resizeEventType, this.updateTableSize);

        console.log('initialize componentDidMount');
        this.initialize(null);
    }

    componentDidUpdate(prevProps) {
        console.log('initialize componentDidUpdate');
        this.initialize(prevProps);

        if ((prevProps.isVisible !== this.props.isVisible) && this.props.isVisible) {
			/* Adjust record table column widths */
			var allFetched = false;
			if (prevProps != null &&
				prevProps.recordsState != null &&
				this.props.recordsState != null &&
				prevProps.recordsState.all !== this.props.recordsState.all) {
				allFetched = true;
			}
			this.updateTableSize(allFetched);
		}
    }

    componentWillUnmount() {
        window.removeEventListener(resizeEventType, this.updateTableSize);
    }

    handleRecordSelected(id, serviceType, studyId) {
        const activeId = this.state.activeId;
        var element = document.getElementById(id);
        const selected = " selected";

        if (element == null) {
            return;
        }

        if (activeId === "") {
            // Add selected pseudo for CSS styling
            element.className += selected;
        }
        else {
            if (id === activeId) {
                id = "";
            }
            else {
                element.className += selected;
                element = document.getElementById(activeId);
            }

            // Remove selected pseudo
            var cn = element.className;
            const selectedIndex = cn.indexOf(selected);
            if (selectedIndex >= 0) {
                cn = cn.replace(selected, "");
            }
            element.className = cn;
        }

		/* find the specific crf answers for this particular record, not just the questions for the study */
		var crfQnaEvent = [];
		var crfQnaHolter = [];
		var crfQna12Lead = [];
		const rec = this.props.recordsState.all.find( function (rec) { return rec.id === id } );
		if ( rec ) {
			crfQnaEvent = rec.crfQnaEvent;
			crfQnaHolter = rec.crfQnaHolter;
			crfQna12Lead = rec.crfQna12Lead;
		}

        this.setState({
            activeId: id,
			selectedId: "",
			crfQnaEvent: crfQnaEvent,
			crfQnaHolter: crfQnaHolter,
			crfQna12Lead: crfQna12Lead,
            serviceType: serviceType,
            studyId: studyId
        });
    }

    initialize(prevProps) {
        console.log('initialize ' + this.state.initCount++);

        if (this.state.isInitializing) {
            console.log("already running, leave");
            return;
        }
        else {
            console.log("not running, proceed");
            this.state.isInitializing = true;
        }

        const accountsState = this.props.accountsState;
        const authenticated = Accounts.authenticatedAllRoles(accountsState);
        var isPhysician = false;
        const recordsState = this.props.recordsState;

        if (accountsState.authenticatedAccount != null &&
            accountsState.authenticatedAccount.role === Accounts.accountRoles.Physician) {
            isPhysician = true;
        }

        const allPatientId = recordsState.allPatientId;
        const allSiteId = recordsState.allSiteId;
        const allStudyId = recordsState.allStudyId;
        var patientCode = this.state.patientCode;
        var patientId = this.state.patientId;
        var patientUpdate = patientId !== allPatientId;
        var siteId = this.state.siteId;
        var siteName = this.state.siteName;
        var siteUpdate = siteId !== allSiteId;
        const studyId = this.state.studyId;
        var studyUpdate = studyId !== allStudyId;
        //var studyUpdate = false;
        console.log(studyId + ' | ' + allStudyId);
        console.log('studyUpdate:' + studyUpdate);

        // Check if patient or site filters were cleared
        if (prevProps != null) {
            if (patientUpdate) {
                this.setState({
                    patientCode: recordsState.allPatientCode,
                    patientId: allPatientId
                });
                patientUpdate = false;
            }
            if (siteUpdate) {
                this.setState({
                    siteId: allSiteId,
                    siteName: recordsState.allSiteName
                });
                siteUpdate = false;
            }
        }

        if (studyUpdate &&
            isPhysician) {
            studyUpdate = false;
        }

        console.log('update vars:(' + studyUpdate + ' OR ' + this.props.recordsState.all + ') AND !' + this.props.recordsState.fetching)
        // Fetch record list, if necessary
        const update = ((
            studyUpdate ||
            this.props.recordsState.all == null) &&
            !this.props.recordsState.fetching
        );
        console.log('update:' + update)

		/* erase old records if the study changed */
		if ( studyUpdate && (this.props.recordsState.all && this.props.recordsState.all.length > 0) && ! this.props.recordsState.fetching ) {
            this.props.recordsDispatch.setAll(null);
		}

		if ( this.props.accountsState.authenticated && (this.state.columnsUsed === null || this.state.columnsUsed === undefined) ) {
			(async () => {
				await this.props.settingsDispatch.getAll();
			})().then(() => {
				this.setState({
					columnsUsed: this.props.settingsState.columnsUsed,
				})
			});
		} 

        console.log('authenticatedPrevProps vars:' + prevProps + "-" + authenticated + "-" + accountsState.fetching + "-" + update);
		if (Accounts.authenticatedPrevProps(prevProps, authenticated, accountsState.fetching, update)) {
			this.props.recordsState.patientFilter = null;

            this.setState({
				activeId: ""
            });

			if (isPhysician) {
				this.props.recordsDispatch.getAllRecordList();
			}
			else {
                console.log('calling recordsDispatch.getAllRecordListByStudy ' + this.state.initCount);

                this.props.recordsDispatch.getAllRecordListByStudy(studyId);

				// Only reset filters if fetching records for a new study (not returning from create record)
				if (studyUpdate) {
					this.props.recordsDispatch.setAllStudyName(this.state.studyName);
					patientCode = "";
					patientId = "";
					patientUpdate = true;
					siteId = "";
					siteName = ""
					siteUpdate = true;
				}
			}
		}

        // Update filters, if necessary
        if (patientUpdate) {
            this.props.recordsDispatch.setAllPatient(patientCode, patientId);
        }
        if (siteUpdate) {
            this.props.recordsDispatch.setAllSite(siteId, siteName);
        }

		// show previously selected record
		if ( this.state.selectedId !== "" ) {
			const selected = " selected";
			var element = document.getElementById(this.state.selectedId);
			if ( element ) {
				element.className += selected;
			}
		}

        // Adjust record table column widths
        var allFetched = false;
        if (prevProps != null &&
            prevProps.recordsState != null &&
            this.props.recordsState != null &&
            prevProps.recordsState.all !== this.props.recordsState.all) {
            allFetched = true;
        }
        this.updateTableSize(allFetched);

        console.log("running complete");
        this.state.isInitializing = false;
    }

	toggleFilter() {
		if ( this.state.isShowingFilter ) {
			this.setState({ currentFilters: {} });
		}
		this.setState({ isShowingFilter: ! this.state.isShowingFilter });
	}

	onSortChange = (currentColumn) => {
		let currentSortDirection = this.state.currentSortDirection;
		let nextSort = 'default';

		switch ( currentSortDirection[currentColumn] ) {
			case "down": nextSort = 'default'; break;
			case "up"  : nextSort = 'down'; break;
			default    : nextSort = 'up'; break;
		}

		let newCurrentSortDirection = {};
		newCurrentSortDirection[currentColumn] = nextSort;

		this.setState({
			currentSortDirection: newCurrentSortDirection,
			currentSortingColumn: currentColumn,
		});
	};

	onFilterChange = (e) => {
		this.setState({ currentFilters: {...this.state.currentFilters, [e.target.name]: e.target.value } });
	};

	ColumnHeader = (props) => {
		sortfilter.filterAssociation[props.recordKey] = props.label;
		let val = this.state.currentFilters[props.label];
		if ( val === undefined ) {
			val = '';
		}
		return <sortfilter.ColHeader value={val} onChange={this.onFilterChange.bind(this)} sortDir={this.state.currentSortDirection} onSortChange={this.onSortChange} showFilter={this.state.isShowingFilter} label={props.label} recordKey={props.recordKey} />
	};


    render() {
        const accountsState = this.props.accountsState;
        if (!Accounts.authenticatedAllRoles(accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        const needsRefresh = this.props.recordsState.doRefresh;
		if ( needsRefresh ) {
			this.props.recordsDispatch.setRefresh( false );
			this.props.recordsDispatch.setAll( null );
            this.setState({ scroll: false });
		}

        const createRecordTitle = "Create Record";
        var error = false;
        var message = "";
        var recordList = null;
        const patientCode = this.props.recordsState.allPatientCode;
        const patientId = this.props.recordsState.allPatientId;
        const studyId = this.state.studyId;

        const records = this.props.recordsState.all;
        if (records != null &&
            records.map != null) {
				var rowNum = 1;
				const needsRejectedByMD = this.props.recordsState.allRejectedByMD;
				const needsOverread = this.props.recordsState.allNeedsOverread;
				const needsQa = this.props.recordsState.allNeedsQa;
				const siteName = this.props.recordsState.allSiteName;
				const unread = this.props.recordsState.allUnread;

				let rList = [...records].filter(record => {
					if (needsRejectedByMD &&
						record.status !== Records.recordStatus.rejectedByMd) {
						if ( record.id === this.state.activeId ) {
							this.setState({ activeId: "" });
						}
						return null;
					}
					if (needsOverread &&
						record.status !== Records.recordStatus.needsOverread) {
						if ( record.id === this.state.activeId ) {
							this.setState({ activeId: "" });
						}
						return null;
					}
					if (needsQa &&
						record.status !== Records.recordStatus.needsQa) {
						if ( record.id === this.state.activeId ) {
							this.setState({ activeId: "" });
						}
						return null;
					}
					if (patientCode !== "" &&
						patientCode !== record.patientCode) {
						if ( record.id === this.state.activeId ) {
							this.setState({ activeId: "" });
						}
						return null;
					}
					if (this.props.recordsState.patientFilter
							&& this.props.recordsState.patientFilter !== ""
							&& this.props.recordsState.patientFilter !== record.patientCode) {
						if ( record.id === this.state.activeId ) {
							this.setState({ activeId: "" });
						}
						return null;
					}
					if (siteName !== "" &&
						siteName !== record.siteName) {
						if ( record.id === this.state.activeId ) {
							this.setState({ activeId: "" });
						}
						return null;
					}
					if (unread &&
						unread !== record.isUnread) {
						if ( record.id === this.state.activeId ) {
							this.setState({ activeId: "" });
						}
						return null;
					}
					return record;
				});

				rList = sortfilter.filterData(
					[...rList].map(record => {
						let tzOffset = record.timeZoneOffsetMinutes;
						if ( Math.abs(tzOffset) <= 16 ) {
							tzOffset *= 60;
						}
						return ({ ...record,
							unread: record.isUnread ? "Yes" : "No",
							isQaComplete: record.isQaComplete ? "Yes" : "No",
							isMdOverreadComplete: record.isMdOverreadComplete ? "Yes" : "No",
							isMdOverreadRequired: record.isMdOverreadRequired ? "Yes" : "No",
							recordDateTime: utility.formatDisplayDateTime(moment(record.recordDateTime).add(tzOffset,'m')),
							receiveDateTime: utility.formatDisplayDateTime(moment(record.receiveDateTime).add(tzOffset,'m')),
                            qaCompleteDateTime: utility.formatDisplayDateTime(moment(record.qaCompleteDateTime).add(tzOffset, 'm')),
						});
					}),
					this.state.currentFilters
				);

				recordList = [...rList].sort( sortfilter.sortingDetails(this.state.currentSortingColumn,this.state.currentSortDirection).fn ).map(record => {
					return (
						<tr className="recrow" key={record.id} id={record.id} onClick={this.handleRecordSelected.bind(this, record.id, record.serviceType, record.studyId)}>
							<th scope="row">{rowNum++}</th>
							{ this.state.columnsUsed && this.state.columnsUsed.map( col => { return ( <td key={record.id + "_" + col.fieldname} className="small-font"> {record[ col.fieldname ]} </td>); }) }
						</tr>
					);
				});
		} else {
            error = true;
            message = "Error retrieving records.";
        }

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";
        const recordSelected = this.state.activeId !== "";
        const displayCreate = (
            !recordSelected &&
            patientCode !== "" &&
            Accounts.isHcsRole(accountsState.authenticatedAccount.role)
        );

        var tbodyClass = "tbody-block";
        if (this.state.scroll) {
            tbodyClass += " tbody-scroll";
        }

		let crfQnA = [];
		switch ( this.state.serviceType ) {
			case Records.recordServiceTypes.event:
				crfQnA = this.state.crfQnaEvent;
				break;
			case Records.recordServiceTypes.holter:
				crfQnA = this.state.crfQnaHolter;
				break;
			case Records.recordServiceTypes.twelveLead:
				crfQnA = this.state.crfQna12Lead;
				break;
			default:
				break;
		}

		if ( recordSelected ) {
			/* find the specific crf answers for this particular record, not just the questions for the study */
			var crfQnaEvent = [];
			var crfQnaHolter = [];
			var crfQna12Lead = [];
			const id = this.state.activeId;
			const rec = this.props.recordsState.all.find( function (rec) { return rec.id === id } );
			if ( rec ) {
				crfQnaEvent = rec.crfQnaEvent;
				crfQnaHolter = rec.crfQnaHolter;
				crfQna12Lead = rec.crfQna12Lead;
			}

			const recStatus = rec.status;

            return (
				<Redirect to={
					{
						pathname: paths.viewRecord,
						state: {
							recordId: this.state.activeId,
							recStatus: recStatus,
							serviceType: this.state.serviceType,
							studyId: studyId,
							crfQnaEvent: crfQnaEvent,
							crfQnaHolter: crfQnaHolter,
							crfQna12Lead: crfQna12Lead,
						}
					}
					}
				/>
			);

		} else {

			let title = "Select Record";

			if ( this.props.recordsState.patientFilter && (this.props.recordsState.patientFilter !== "") ) {
				title = title + " for " + this.props.recordsState.patientFilter;
			}


			return (
				<div>
					<h3> {title} </h3>
					<Button className="button filter_button" id="btnFilter" title="Filter" onClick={this.toggleFilter.bind(this)}> Filter </Button>
					<br />
					{displayMessage && <Alert color={alertColor}>{message}</Alert>}
					<Table>
						<tbody className="thead-block" id="recordTableHeader">
							<tr className="recrow">
								<th>#</th>
								{ this.state.columnsUsed && this.state.columnsUsed.map( col => { return( <this.ColumnHeader key={col.text} label={col.text} recordKey={col.fieldname} /> ); }) }
							</tr>
						</tbody>
					</Table>
					<Table striped>
						<tbody className={tbodyClass} id={recordTableBodyId}>
							{recordList}
						</tbody>
					</Table>
					{displayCreate && <Button className="button button-gap" tag={Link} title={createRecordTitle} to={{ pathname: paths.createRecord, state: { patientCode: patientCode, patientId: patientId, studyId: studyId, crfQnA: crfQnA } }}>{createRecordTitle}</Button>}
				</div>
			);
		}
    }

    updateTableSize(allFetched) {
        var adjustArray = null;
        const allRows = document.querySelectorAll(".recrow");
        var columns = null;
        var row = null;

        for (var i = 0; i < allRows.length; i++) {
            row = allRows[i];
            columns = row.children;
            if (row.id !== "") {
                this.updateTableSizeColumns(columns, adjustArray);
            }
            else {
                adjustArray = this.updateTableSizeColumns(columns, null);
            }
        }

        const recordTableBody = document.getElementById(recordTableBodyId);
        var scroll = false;
        const viewHeight = parseInt(document.body.clientHeight * 0.65, 10);   // * 0.65 to match className="tbody-scroll"
        if (allFetched &&
            recordTableBody != null &&
            recordTableBody.clientHeight >= viewHeight) {
            scroll = true;
        }
        if (allFetched &&
            this.state.scroll !== scroll) {
            this.setState({
                scroll: scroll
            });
        }
    }

    updateTableSizeColumns(columns, adjustArray) {
        var i = 0;
        const numColumns = columns.length;

        if (adjustArray == null) {
            adjustArray = [];
            var allColumnsWidth = 0;
            var columnWidth = 0;
            const recordTableBody = document.getElementById(recordTableBodyId);
            var rowCountColumn = null;
            const tableWidth = recordTableBody && recordTableBody.clientWidth;

			if ( ! recordTableBody ) {
				return null;
			}

            if (recordTableBody.firstChild != null &&
                recordTableBody.firstChild.firstChild != null) {
                rowCountColumn = recordTableBody.firstChild.firstChild;
            }

            for (i = 0; i < numColumns; i++) {
                if (i === 0 &&
                    rowCountColumn != null) {
                    // Row count column will be larger in the body than header if >= 10
                    columnWidth = rowCountColumn.offsetWidth;
                }
                else {
                    columnWidth = columns[i].offsetWidth;
                }
                adjustArray.push(columnWidth);
                allColumnsWidth += columnWidth;
            }

            // Divide by 5 to only add remaining width to the columns to the right of the service type column
            const widthAdjust = (tableWidth - allColumnsWidth) / 5;
            for (i = 5; i < numColumns; i++) {
                adjustArray[i] += widthAdjust;
            }
        }

        for (i = 0; i < numColumns; i++) {
            columns[i].width = adjustArray[i];
        }

        return adjustArray;
    }
}

const SelectRecordConnect = connect(
    state => ({
        accountsState: state.accounts,
        recordsState: state.records,
        settingsState: state.settings
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        recordsDispatch: bindActionCreators(Records.actionCreators, dispatch),
        settingsDispatch: bindActionCreators(MySettings.actionCreators, dispatch)
    })
)(SelectRecordInternal);

export default class SelectRecord extends React.Component {
    render() {
        var patientCode = null;
        var patientId = null;
        var siteId = null;
        var siteName = null;
        var studyId = null;
        var studyName = null;
		var isVisible = false;
		var selectedId = "";

        const propsState = this.props.state || this.props.location.state;
        if (propsState != null) {
            if (propsState.patientCode != null) {
                patientCode = propsState.patientCode;
            }
            if (propsState.patientId != null) {
                patientId = propsState.patientId;
            }
            if (propsState.siteId != null) {
                siteId = propsState.siteId;
            }
            if (propsState.siteName != null) {
                siteName = propsState.siteName;
            }
            if (propsState.studyId != null) {
                studyId = propsState.studyId;
            }
            if (propsState.studyName != null) {
                studyName = propsState.studyName;
            }
            if (propsState.selectedId != null) {
                selectedId = propsState.selectedId;
            }
            if (propsState.isVisible != null) {
                isVisible = propsState.isVisible;
            }
        }

        return (
            <ErrorBoundary>
                <SelectRecordConnect isVisible={isVisible} patientCode={patientCode} patientId={patientId} siteId={siteId} siteName={siteName} studyId={studyId} studyName={studyName} selectedId={selectedId} />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SelectRecord.js